import React, { useState, useMemo, useEffect } from "react";
import { isEmpty } from "../../../utils";
import useDataFetch, {
  DataFetchOptionsType,
} from "../../../hooks/useDataFetch";
import { getCandidatesData, getCandidatesData2 } from "../services";
import RenderLoading from "./partials/renderLoading";
import RenderError from "./partials/renderError";
import RenderTable from "./partials/renderTable";
import RenderHeader from "./partials/renderHeader";
import { initialColumns, totalColumns } from "../registry";
import { FiltersType } from "./types";

interface Candidate {
  id: number;
  name: string;
  email: string;
  status: "Not Started" | "In Progress" | "Completed";
  [key: string]: any;
}

const ReportGrid = ({
  gridDataAPI,
  assessmentId,
  visibleColumns,
  setVisibleColumns,
  headerData,
}) => {
  // const [fetchOptions, setFetchOptions] = useState<DataFetchOptionsType>({
  //   error: { msg: "API Failed" },
  // });
  const [fetchOptions, setFetchOptions] = useState<DataFetchOptionsType>({
    res: [...gridDataAPI],
  });
  const { loading, data, error } = useDataFetch(
    () => getCandidatesData2(assessmentId),
    fetchOptions
  );

  const [selectedRows, setSelectedRows] = useState<number[]>([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [allColumns, setAllColumns] = useState(initialColumns);
  const [gridData, setGridData] = useState([...gridDataAPI]);
  const [filters, setFilters] = useState({});

  const updateSelectedRows = (rows) => {
    setSelectedRows([...rows]);
  };

  const updateSearchTerm = (searchText) => {
    setSearchTerm(searchText);
  };

  const updateVisibleColumns = (columns) => {
    setVisibleColumns(columns);
  };

  const applyFilters = (filters: FiltersType, reset: boolean) => {
    if (reset) {
      setFilters({});
      return;
    }
    const validFilters = Object.keys(filters).reduce((acc, key) => {
      const value = filters[key];
      if (value !== undefined && value !== null) acc[key] = value;
      return acc;
    }, {});
    setFilters((prevFilters) => ({ ...prevFilters, ...validFilters }));
  };

  useEffect(() => {
    if (!isEmpty(data)) {
      setGridData(data);
    }
  }, [data]);

  useEffect(() => {
    if (gridData) {
      const formFieldsColumns = gridDataAPI[0].formFields.map((formField) => {
        return { label: formField.label, key: formField.id };
      });
      setAllColumns([...totalColumns, ...formFieldsColumns]);
      setVisibleColumns([...initialColumns]);
    }
  }, [gridData]);

  if (loading) {
    return <RenderLoading />;
  }

  if (error) {
    return (
      <RenderError
        error={error}
        onRetry={() => {
          setFetchOptions({
            loading: true,
          });
          setTimeout(() => {
            setFetchOptions({ requestId: new Date().getTime().toString() });
          }, 1000);
        }}
      />
    );
  }

  return (
    <div className="max-w-[1302px] w-full xl:card max-h-full h-full">
      <RenderHeader
        applyFilters={applyFilters}
        gridData={gridData}
        selectedRows={selectedRows}
        visibleColumns={visibleColumns}
        searchTerm={searchTerm}
        updateSearchTerm={updateSearchTerm}
        initialColumns={allColumns}
        updateVisibleColumns={setVisibleColumns}
      />

      <RenderTable
        filters={filters}
        gridData={gridData}
        searchTerm={searchTerm}
        selectedRows={selectedRows}
        updateSelectedRows={updateSelectedRows}
        visibleColumns={visibleColumns}
        header={headerData}
      />
    </div>
  );
};

export default ReportGrid;
